<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> {{labels.dateRangeTitle}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
              <v-card>
                <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="forms.asAtDate" :label="labels.asAtDate" :data-vv-as="labels.asAtDate" data-vv-name="asAtDate" :error-messages="errors.collect('asAtDate')" v-validate="'required'"></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                </v-card-text>
              </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> {{labels.filters}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete :items="accmTypeList" v-model="forms.accmType" :label="labels.accmType" item-text="label" item-value="value" data-vv-name="accmType" :data-vv-as="labels.accmType" :error-messages="errors.collect('accmType')" v-validate="'required'"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete :items="rptTypeList" v-model="forms.rptType" :label="labels.rptType" item-text="label" item-value="value" data-vv-name="rptType" :data-vv-as="labels.rptType" :error-messages="errors.collect('rptType')" v-validate="'required'"></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12>
          <v-checkbox dense v-model="forms.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" dark :loading="processing" @click.prevent="doSubmit">
            <v-icon left dark>mdi-file-export</v-icon>
            {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="forms.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-information</v-icon>
        <v-toolbar-title>System Information</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div v-if="messages.length > 0" class="pb-3">
        <v-subheader>Oops something went wrong:</v-subheader>
        <ul class="showErrorMsgs">
          <li v-for="(error, index) in messages" :key="index">
          {{error.message}}
          </li>
        </ul>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      labels: {
        dateRangeTitle: 'Date Range',
        modules: 'Modules',
        asAtDate: 'As At Date*',
        filters: 'Selection Criteria',
        accmType: 'Accumulation Type',
        rptType: 'Report Type',
        export: 'Export To',
        printRptRunTime: 'Print Runtime Parameters'
      },
      forms: {
        asAtDate: null,
        accmType: null,
        format: 'PDF',
        printRptRunTime: true,
        rptType: 'floatSI'
      },
      processing: false,
      showErrorDialog: false,
      supportedFormat: [],
      menu: {},
      accmTypeList: [],
      rptTypeList: [
        { label: 'Sum Insured', value: 'si' },
        { label: 'Floating Sum Insured', value: 'floatSI' }
      ],
      panel1: [0],
      panel2: [0]
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.forms.format = value[0].value
      }
    },
    'displayErrorDialog': {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    displayErrorDialog() {
      return this.messages
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initTtyLimChkList
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.getAccmTypeList()
      } catch (err) {
        throw err
      }
      this.forms.asAtDate = new Date()
    },
    async getAccmTypeList() {
      const apiURI = this.menu.accumTypeList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.accmTypeList = []
          if (data) {
            for (let i in data) {
              this.accmTypeList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url. [getAccmTypeList]')
      }
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiUrl = this.menu.exportTtyLimChkList
      if (apiUrl) {
        try {
          this.processing = true
          await this.$http.post(apiUrl, this.forms)
          this.$toast.success('Submitted Successfully.')
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportTtyLimChkList]')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>
